import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ClientSelection } from './pages/ClientSelection';
import { Rassegne } from './pages/Rassegne';
import { RassegnaDetail } from './pages/RassegnaDetail';
import { ArticleDetail } from './pages/ArticleDetail';
import { ReportGenerator } from './pages/ReportGenerator';
import { ReportBuilder } from './pages/ReportBuilder';
import { Settings } from './pages/Settings';
import { TierManagement } from './pages/TierManagement';
import { ClientDashboard } from './pages/ClientDashboard';
import { Homepage } from './pages/Homepage';
import { Statistics } from './pages/Statistics';
import { Login } from './pages/Login';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Client Read-Only View (No Layout) */}
        <Route path="/client" element={<ClientDashboard data-id="element-3" />} data-id="element-2" />

        {/* Entry Flow */}
        <Route path="/" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/select-client" element={<ClientSelection data-id="element-7" />} data-id="element-6" />

        {/* Main App Routes (With Layout) */}
        <Route path="/*" element={<Layout data-id="element-9">
              <Routes data-id="element-10">
                <Route path="/home" element={<Homepage data-id="element-12" />} data-id="element-11" />
                <Route path="/rassegne" element={<Rassegne data-id="element-14" />} data-id="element-13" />
                <Route path="/rassegne/:id" element={<RassegnaDetail data-id="element-16" />} data-id="element-15" />
                <Route path="/article/:id" element={<ArticleDetail data-id="element-18" />} data-id="element-17" />
                <Route path="/statistics" element={<Statistics data-id="element-20" />} data-id="element-19" />
                <Route path="/reports/new" element={<ReportBuilder data-id="element-22" />} data-id="element-21" />
                <Route path="/reports" element={<ReportGenerator data-id="element-24" />} data-id="element-23" />
                <Route path="/settings/algorithm" element={<Settings data-id="element-26" />} data-id="element-25" />
                <Route path="/settings/connectors" element={<Settings data-id="element-28" />} data-id="element-27" />
                <Route path="/settings/tiers" element={<TierManagement data-id="element-30" />} data-id="element-29" />
                <Route path="/settings" element={<Navigate to="/settings/connectors" replace data-id="element-32" />} data-id="element-31" />

                {/* Legacy redirects */}
                <Route path="/dashboard" element={<Navigate to="/home" replace data-id="element-34" />} data-id="element-33" />
                <Route path="/upload" element={<Navigate to="/rassegne" replace data-id="element-36" />} data-id="element-35" />
                <Route path="/archive" element={<Navigate to="/rassegne" replace data-id="element-38" />} data-id="element-37" />
              </Routes>
            </Layout>} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}